import React, { useEffect, useState, useMemo, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router";
import headerCSS from "../../styles/header.module.scss";
import $ from "jquery";
import { setLogin } from "../../reduxStore/login/loginSlice";
import { IsLoggedIn as loginStatus } from "../../utility/features/helpers/authHelper";
import Storage from "../../utility/features/helpers/storageHelper";
import fallbackData from "../../json/globalContent.json";
import ecommEndpoints from "../../utility/features/endPoints/ecommEndpoints";
import { slugify } from "../../utility/utils/slugify";
import store from "../../reduxStore/store";
import { customerServiceNumberFormatted } from '../../utility/utils/formatter';
import { setData } from "../../reduxStore/globalContent/globalContentSlice";
import { setCustomerInfo } from "../../reduxStore/login/loginSlice";
import customerSummaryClient from "../../utility/apiClients/customer/customerSummaryClient";

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userData, customerInfo } = store.getState().login;

  const [customerSummaryData, setCustomerSummaryData] = useState(customerInfo?.[0] || null);

  const dropdownMenuRef = useRef(null);
  const dropdownMenuRefMobile = useRef(null);
  const isLoggedIn = loginStatus();
  const offCanvasRef = useRef({});
  const baseUrl = process.env.REACT_APP_CMS_URL;
  const navigate = useNavigate();
  const globalContentData = useSelector(store => store.globalContent.data) || fallbackData;
  const selAdd = store.getState().accountSummary.selectedServiceAddress;
  const custNum =
    location?.state && location?.state?.custNo && location?.state?.custNo !== ""
      ? location?.state?.custNo
      : selAdd
      ? selAdd.split(" | ")?.[1]
      : localStorage.getItem("customerNumbers")
      ? JSON.parse(localStorage.getItem("customerNumbers"))[0]
      : "User";
  
  useEffect(() => {
    //Mobile menu icon onclick
    $(document).on("click", `.mob-menu-ham`, function () {
      $(`.${headerCSS["mob-navlist"]}`).show();
      $(`.mob-menu-ham`).hide();
      $(`.${headerCSS["close-btn"]}`).show();
      $(`.${headerCSS["mobile-nav"]}`).addClass(headerCSS["mobile-nav-open"]);
    });

    //Close button onclick of mobile menu
    $(document).on("click", `.${headerCSS["close-btn"]}, .${headerCSS["logout-link"]}, .mob-offcanvas-close`, function () {
      $(`.${headerCSS["mob-navlist"]}, .${headerCSS["close-btn"]}`).hide();
      $(`.mob-menu-ham, .${headerCSS["top-strip"]}`).show();
      $(`.${headerCSS["mobile-nav"]}`).removeClass(
        headerCSS["mobile-nav-open"]
      );
    });

    $(window).scroll(function () {
      if ($(window).scrollTop() >= 0) {
        $(`.${headerCSS["main-green-nav"]}`).addClass(
          headerCSS["fixed-nav"]
        );
        $(`.${headerCSS["mobile-nav"]}`).addClass(headerCSS["fixed-nav"]);
      } else {
        $(`.${headerCSS["main-green-nav"]}`).removeClass(
          headerCSS["fixed-nav"]
        );
        $(`.${headerCSS["mobile-nav"]}`).removeClass(headerCSS["fixed-nav"]);
      }
    });
  }, []);

  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const myAccountMenu = [{
    below: [
        {
            title: "",
            below: [{
                title: "Account Summary",
                description: "Pay your balance or view your payment history.",
                url: "my-account/account-summary"
            }]
        },
        {
            title: "",
            below: [{
                title: "Payments",
                description: "Pay your balance or view your payment history.",
                url: "my-account/payments"
            }]
        },
        {
            title: "",
            below: [{
                title: "Service Details",
                description: "Get information about your plans or services and view invoices.",
                url: "my-account/my-services"
            }]
        },
        {
            title: "",
            below: [{
                title: "Account Settings",
                description: "Manage your payments (including EasyPay), contact information and more.",
                url: "my-account/account-settings"
            }]
        },
        {
            title: "",
            below: [{
                title: "My Documents",
                description: "View your summaries and other important documentation.",
                url: "my-account/my-documents"
            }]
        },
        {
            title: "",
            below: [{
                title: "Help",
                description: `Call: <a href="tel:${customerServiceNumberFormatted}" >${customerServiceNumberFormatted}</a>`,
                url: ""
            }]
        }
    ],
    title: customerInfo ? customerInfo?.[0]?.BusinessName+"'s Account" : "My Account"
  }];

  const handleDropDownToggle = (e, isMobile) => {
    const element = e.target;
    if(element){
      element.classList.toggle("show")
    }
    isMobile ?   dropdownMenuRefMobile.current?.classList.toggle("show") :
    dropdownMenuRef.current?.classList.toggle("show") ;
    
  };

  const closeMobileMenu = () => {
    $(`.${headerCSS["mob-navlist"]}, .${headerCSS["close-btn"]}`).hide();
    $(`.mob-menu-ham, .${headerCSS["top-strip"]}`).show();
    $(`.${headerCSS["mobile-nav"]}`).removeClass(headerCSS["mobile-nav-open"]);
  };

  const handleMyAccountSubmenuClick = (e, url) => {
    e.preventDefault();
    navigate(url);

    const offcanvasEl = e.currentTarget?.closest(".offcanvas");
    if (offcanvasEl && window.bootstrap?.Offcanvas) {
      window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).hide();
    } else if (offcanvasEl) {
      offcanvasEl.classList.remove("show");
    }

    closeMobileMenu();
  };

  const openOffcanvasMenu = (e, offcanvasId) => {
    e.preventDefault();
    const offcanvasEl = document.getElementById(offcanvasId);

    if (offcanvasEl && window.bootstrap?.Offcanvas) {
      window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl).show();
    } else if (offcanvasEl) {
      offcanvasEl.classList.add("show");
    }
  };

  useEffect(() => {
    const ac = new AbortController();
          
      (async () => {
        try {
          setLoading(true);
          setErr(null);
          const res = await fetch(
            process.env.REACT_APP_ECOMM_URL + ecommEndpoints.getGlobalContent(),
            { signal: ac.signal }
          );
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const json = await res.json();
          const data = Array.isArray(json) ? json[0] : json; // API returns an array
          
          dispatch(setData(data));
        } catch (e) {
          if (fallbackData) {
            const data = Array.isArray(fallbackData)
              ? fallbackData[0]
              : fallbackData;
            
            dispatch(setData(data));
          } else if (e.name !== "AbortError")
            setErr(e.message || "Failed to load global content");
        } finally {
          setLoading(false);
        }
      })();
    
    return () => ac.abort(); // Cancel if component unmounts
  }, []);
  
  const { mainHeaderItems, commercialSubMenu, contactUsNode } = useMemo(() => {
    let currentItem = {};
    if (!globalContentData) return {};
    const mainMenu = globalContentData ? globalContentData.main_menu : null;
    const mainHeaderItems = [];
    let commercialSubMenu = null;
    let contactUsNode = null;
    mainMenu.forEach((menuItem, index) => {
      currentItem = {};
      currentItem.title = menuItem.title;
      currentItem.url =
        menuItem.title === "Residential"
          ? process.env.REACT_APP_RESI_URL || menuItem.url
          : menuItem.url;
      mainHeaderItems.push(currentItem);

      if (index === 1) {
        commercialSubMenu = [];
        menuItem.below.forEach((item) => {
          if (item.title.toLowerCase().includes("contact us")) {
            contactUsNode = item;
          } else {
            commercialSubMenu.push(item);
          }
        });
      }
    });
    return { mainHeaderItems, commercialSubMenu, contactUsNode };
  }, [globalContentData]);

  if (!mainHeaderItems || err) return null;

  const renderDropDown = (subMenu) => {
    return (
      <div className={headerCSS["dropdown-nav"]} key={subMenu.title}>
        <button className={headerCSS["dropbtn"]}>
          {subMenu.title}
          <img src="/images/header/Cheveron-1.png" alt="cheveron-icon" />
        </button>
        <div className={headerCSS["dropdown-contents"]}>
          <div className={headerCSS["rows"]}>
            {subMenu.below.map((section) => renderSection(section))}
          </div>
        </div>
      </div>
    );
  };

  const renderSection = (section, isMobile = false, isMyAccountMenu = false) => {
    if (isMobile) {
      return (
        <Fragment key={section.title}>
          {section.title !== "" && <div className={`${headerCSS["nav-title"]} ${headerCSS["text-left"]}`}>
            {section.title}
          </div>
          }
          <ul>
            {section.below.map((ele) => {
              let url = ele.url;
              if (!isMyAccountMenu) {
                url = url.startsWith("/")
                  ? `${baseUrl}${url}`
                  : `${baseUrl}/${url}`;
              }
              const myAccountUrl = ele.url?.startsWith("/") ? ele.url : `/${ele.url}`;
                
              return (
                <li key={ele.title}>
                    {section.title !== ""
                    ? <a href={url} className="mob-offcanvas-close" onClick={closeMobileMenu}>{ele.title}</a>
                    : (
                      ele.title !== "Help"
                        ? <Link to={myAccountUrl} onClick={(e) => handleMyAccountSubmenuClick(e, myAccountUrl)}>{ele.title}</Link>
                        : <a href="#" onClick={closeMobileMenu}>{ele.title}</a>
                    )
                    }
                    {ele.title !== "Help"
                     ? <p>{ele.description ? ele.description : null}</p>
                     : <p dangerouslySetInnerHTML={{__html: ele.description}}></p>
                    }
                </li>
              );
            })}
          </ul>
        </Fragment>
      );
    }
    return (
      <div className={headerCSS["column"]}>
        <h3>{section.title}</h3>

        {section.below.map((ele) => {
          let url = ele.url;
          url = `${baseUrl}${url}`;
          return (
            <div className={headerCSS["col-page-link"]} key={ele.title}>
              <a href={url} className={headerCSS["plan-link"]}>
                {ele.title}
              </a>
              {ele.description ? <p>{ele.description}</p> : null}
            </div>
          );
        })}
      </div>
    );
  };

  const renderOffScreenCanvas = (subMenu, isMyAccountMenu = false) => {
    const offcanvasId = isMyAccountMenu
      ? "offcanvasRightMyAccount"
      : "offcanvasRight" + slugify(subMenu.title);

    const offCanvasNode = (
      <div
        className={`offcanvas ${headerCSS["offcanvas-end"]}`}
        tabIndex="-1"
        id={offcanvasId}
        data-bs-backdrop="false"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className={headerCSS["offcanvas-header"]}>
          <div className={headerCSS["green-b"]}>
            <a href="#" data-bs-dismiss="offcanvas" aria-label="Close" onClick={(e) => { e.preventDefault(); }}>
              <img src="/images/header/cheveron-left.svg" alt="" />
            </a>
          </div>
          <div className={headerCSS["gray-b"]}>
            <h5 id="offcanvasRightLabel" className={headerCSS["nav-title"]}>
              {subMenu.title}
            </h5>
          </div>
          <div className={headerCSS["gray-b"]}>
            <a
              href="#"
              onClick={(e) => { e.preventDefault(); }}
              className={`${headerCSS["btn-close"]} text-reset`}
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <img src="/images/header/close-btn.svg" alt="" />
            </a>
          </div>
        </div>

        <div className={headerCSS["offcanvas-body"]}>
          {subMenu.below.map((section, index) => (
            <Fragment key={section.title}>
              {index > 0 && !subMenu.title.includes("Account") && <hr />}
              {renderSection(section, true, isMyAccountMenu)}
            </Fragment>
          ))}
        </div>
      </div>
    );

    offCanvasRef.current = {
      ...offCanvasRef.current,
      [offcanvasId]: offCanvasNode,
    };

    return (
      <li>
        <a
          href="#"
          className="offcanvas-trigger"
          aria-controls="offcanvasRight"
          onClick={(e) => openOffcanvasMenu(e, offcanvasId)}
        >
          {subMenu.title}
          <img
            src="/images/header/Cheveron.png"
            className={headerCSS["mob-arrowicon"]}
            alt=""
          />
        </a>
      </li>
    );
  };

  return (
    <header className="top-header">
      {/* Green Nav Starts */}
      <div
        className={` ${headerCSS["main-green-nav"]} ${headerCSS["desktop-h"]}`}
        id="main-green-nav"
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-5">
              <ul>
                {mainHeaderItems.map((item) => (
                  <li key={item.title}>
                    <a
                      href={item.url}
                      id={item.title}
                      className={item.url === "/" ? headerCSS["active"] : ""}
                    >
                      {item.title+" "}
                      {item.url !== "/" && <img src="/images/header/arrow-out-sm.svg" alt="arrow_icon" />}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="col-md-7 d-flex justify-content-end">
              <div className={headerCSS["login-info"]}>
                {isLoggedIn ? (
                  <>
                    {location.pathname.includes("/my-account") ? (
                      <Link to="/my-invoices">My Invoices</Link>
                    ) : (
                      <Link to="/my-account/account-summary">My Account</Link>
                    )}
                    <Link
                      to="/login"
                      onClick={async (e) => {
                        e.preventDefault();
                        dispatch(setLogin({ ...userData, isLoggedIn: false }));
                        await Storage.logoutUser();
                        localStorage.clear();
                        navigate("/login", { replace: true });
                      }}
                    >
                      Logout
                    </Link>
                  </>
                ) : (
                  <Link to="/login">Log In</Link>
                )}
              </div>
              <div className={headerCSS["login-info"]}>
                <a href={`tel:${customerServiceNumberFormatted}`}>
                  Call {customerServiceNumberFormatted}
                </a>
              </div>
              <div
                className={`country ${headerCSS["country"]} ${headerCSS["dropdown"]}`}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  aria-expanded="false"
                  onClick={handleDropDownToggle}
                >
                  <img src="/images/header/us-icon.png" alt="US_ICON" /> US/EN
                </button>

                <ul
                  className={`dropdown-menu ${headerCSS["lang-card"]}`}
                  aria-labelledby="dropdownMenuButton1"
                  ref={dropdownMenuRef}
                >
                  <li>
                    {" "}
                    <a
                      className="dropdown-item"
                      href={process.env.REACT_APP_DOMAIN_URL}
                    >
                      <img src="/images/header/us-icon.png" alt="US_ICON" />
                      US/EN
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a
                      className="dropdown-item"
                      href="https://www.trugreen.ca/"
                    >
                      <img src="/images/header/can-icon.png" alt="CA_ICON" />
                      CA/EN
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className={headerCSS["mega-menu"]}>
          <div className={`container-fluid ${headerCSS["space-LR"]}`}>
            <div className="row justify-content-between">
              <div className={`col-10 ${headerCSS["col-nav"]}`}>
                <div className={`${headerCSS["navbar-menu"]} res-panel`}>
                  <a href={process.env.REACT_APP_DOMAIN_URL}>
                    <img src="/images/header/logo.svg" alt="logo" />
                  </a>

                  {commercialSubMenu.map((subMenu) => {
                    if (subMenu.below.length > 0)
                      return renderDropDown(subMenu);
                    else
                      return (
                        <a key={subMenu.title} href={`${baseUrl}${subMenu.url}`}>{subMenu.title}</a>
                      );
                  })}
                </div>
              </div>

              <div
                className={`col-2 ${headerCSS["col-btn"]} ${headerCSS["branch-cls"]}`}
              >
                <a
                  href={process.env.REACT_APP_DOMAIN_URL+contactUsNode.url}
                  className={headerCSS["plan-finder"]}
                >
                  {contactUsNode.title}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile menu starts here */}
      <div className={`mobile-nav ${headerCSS["mobile-nav"]}`}>
        <div className="row">
          <div className="col-6">
            <a href={process.env.REACT_APP_DOMAIN_URL}>
              <img src="/images/header/logo.svg" alt="logo" />
            </a>
          </div>
          <div className="col-6">
            <div className={headerCSS["text-right"]}>
              <a href={`tel:${customerServiceNumberFormatted}`} className={headerCSS["mob-links"]}>
                <img src="/images/header/Call.png" alt="call" />
              </a>
              
              <a href="#" className={`${headerCSS["mob-links"]} ${headerCSS["close-btn"]}`} onClick={(e) => { e.preventDefault(); }} >
                <img src="/images/header/close-btn.png" alt="close" />
              </a>
              <a href='#' className={`${headerCSS["mob-links"]} mob-menu-ham`} onClick={(e) => { e.preventDefault(); }} >
                <img src="/images/header/Menu.png" alt="menu" />
              </a>
            </div>
          </div>
        </div>

        <div className={headerCSS["mob-navlist"]}>
          <ul>
            {commercialSubMenu.map((subMenu) => {
              if (subMenu.below.length > 0)
                return renderOffScreenCanvas(subMenu);
              else
                return (
                  <li key={subMenu.title}>
                    <Link to={`${baseUrl}${subMenu.url}`}>{subMenu.title}</Link>
                  </li>
                );
            })}
          </ul>

          <hr />

          <a
            href={process.env.REACT_APP_DOMAIN_URL+contactUsNode.url}
            className={headerCSS["plan-finder-link"]}
          >
            {contactUsNode.title}
          </a>

          <hr />

          {isLoggedIn && (
            <>
              <div className={headerCSS["account-show"]}>
                <ul>{renderOffScreenCanvas(myAccountMenu[0], true)}</ul>
              </div>
              <Link to="/my-invoices" className={`${headerCSS["nav-bottom-link"]} mob-offcanvas-close`}>
                My Invoices
              </Link>

              <br />
              <Link
                to="/login"
                onClick={() => {
                  dispatch(setLogin({ ...userData, isLoggedIn: false }));
                  Storage.logoutUser();
                  localStorage.clear();
                }}
                className={headerCSS["logout-link"]}
              >
                Logout
              </Link>

              <hr />
            </>
          )}

          {!isLoggedIn && (
            <Link to="/login" className={`${headerCSS["nav-bottom-link"]} mob-offcanvas-close`}>
              Log In
            </Link>
          )}

          <ul>
            <li className={headerCSS["nav-li-link"]}>
              <a
                href={`tel:${customerServiceNumberFormatted}`}
                className={headerCSS["nav-bottom-link"]}
              >
                Call {customerServiceNumberFormatted}
              </a>
            </li>
            <li className={headerCSS["nav-li-link"]}>
              <a
                href="https://www.trugreen.com/"
                className={headerCSS["nav-bottom-link"]}
              >
                Switch to <b>Residential</b>{" "}
                <img src="/images/header/Arrow-out-bl.png" alt="" />
              </a>
            </li>
            <li className={headerCSS["nav-li-link"]}>
              <a
                href="https://www.trugreenjobs.com/"
                className={headerCSS["nav-bottom-link"]}
              >
                Explore <b>TruGreen Careers</b>
                <img src="/images/header/Arrow-out-bl.png" alt="" />
              </a>
            </li>

            <div className={`${headerCSS["country"]} ${headerCSS["dropdown"]}`}>
              <button
                className=" dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={(e) => handleDropDownToggle(e, true)}
              >
                <img src="/images/header/us-icon.png" /> US/EN
              </button>
              <ul
                className={`dropdown-menu ${headerCSS["lang-card"]}`}
                aria-labelledby="dropdownMenuButton1"
                ref={dropdownMenuRefMobile}
              >
                <li>
                  {" "}
                  <a
                    className={headerCSS["dropdown-item"]}
                    href={process.env.REACT_APP_DOMAIN_URL}
                  >
                    <img src="/images/header/us-icon.png" alt="" />
                    US/EN
                  </a>
                </li>
                <li>
                  {" "}
                  <a
                    className={headerCSS["dropdown-item"]}
                    href="https://www.trugreen.ca/"
                  >
                    <img src="/images/header/can-icon.png" alt="" />
                    CA/EN
                  </a>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        {Object.values(offCanvasRef.current).map(
          (offScreenCanvas) => offScreenCanvas
        )}
      </div>
      {/* Mobile menu ends here */}
    </header>
  );
};

export default Header;